import React, { useEffect } from 'react';

/** <model-viewer> for a generated .glb; loaded only on the 3D generator (it registers a custom element). */
export const ModelPreview: React.FC<{ src: string; alt: string; testId?: string }> = ({ src, alt, testId = 'model-preview' }) => {
  useEffect(() => {
    import('@google/model-viewer').catch(() => undefined);
  }, []);
  return React.createElement('model-viewer', {
    src,
    alt,
    'camera-controls': true,
    'auto-rotate': true,
    'shadow-intensity': '1',
    'camera-orbit': '30deg 60deg auto',
    'data-testid': testId,
    style: { width: '100%', height: '100%', background: 'transparent' },
  });
};
